import axios from 'axios';
import { searchPostOffices } from '../utils/csvSearch';
import { PostOffice } from '../types';

const api = axios.create({
  baseURL: 'https://api.postalpincode.in',
});

export interface ApiResponse {
  Message: string;
  Status: string;
  PostOffice: PostOffice[];
}

export class ApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export const validatePincode = (pincode: string): boolean => {
  return /^\d{6}$/.test(pincode);
};

const convertToApiResponse = (results: any[]): ApiResponse[] => {
  if (results.length === 0) {
    return [{
      Message: 'No records found',
      Status: 'Error',
      PostOffice: []
    }];
  }

  return [{
    Message: 'Success',
    Status: 'Success',
    PostOffice: results.map(po => ({
      Name: po.officename,
      Description: po.officeType,
      BranchType: po.officeType,
      DeliveryStatus: po.Deliverystatus,
      Circle: po.circlename,
      District: po.Districtname,
      Division: po.divisionname,
      Region: po.regionname,
      Block: po.Taluk,
      State: po.statename,
      Country: 'India',
      Pincode: po.pincode
    }))
  }];
};

export const searchByPincode = async (pincode: string): Promise<ApiResponse[]> => {
  try {
    // First try the API
    try {
      const response = await api.get<ApiResponse[]>(`/pincode/${pincode}`);
      const data = response.data;
      
      if (data[0]?.Status === 'Success' && data[0]?.PostOffice?.length > 0) {
        return data;
      }
    } catch (error) {
      console.log('API search failed, falling back to CSV data');
    }

    // If API fails or returns no results, try CSV
    const results = await searchPostOffices(pincode);
    if (results.length > 0) {
      return convertToApiResponse(results);
    }

    throw new ApiError('No results found');
  } catch (error) {
    throw new ApiError('No results found');
  }
};

export const searchByPostOffice = async (name: string): Promise<ApiResponse[]> => {
  try {
    // First try the API
    try {
      const response = await api.get<ApiResponse[]>(`/postoffice/${name}`);
      const data = response.data;
      
      if (data[0]?.Status === 'Success' && data[0]?.PostOffice?.length > 0) {
        return data;
      }
    } catch (error) {
      console.log('API search failed, falling back to CSV data');
    }

    // If API fails or returns no results, try CSV
    const results = await searchPostOffices(name);
    if (results.length > 0) {
      return convertToApiResponse(results);
    }

    throw new ApiError('No results found');
  } catch (error) {
    throw new ApiError('No results found');
  }
};
